import { NotificationStyle } from "@/lib/models/notifications";
import { clearNotification, showNotification } from "@/lib/notifications";
import { localization } from "@/lib/resources";

let cadenasLoaded = false;

/**
 * Lädt Cadenas JS und CSS.  
 * **ACHTUNG**: Cadenas' Bundle ist sehr groß, deswegen darf es
 * erst geladen werden, wenn es gebraucht wird!
 */
export async function loadCadenas(): ReturnType<typeof rawImport> {
	if (cadenasLoaded) return rawImport();

	// Nach 2s eine "bitte warten" Notification anzeigen, die nicht von alleine verschwindet
	let timeout = setTimeout(() => showNotification(NotificationStyle.Info, localization("3DVorschauWirdGeladen"), 0), 2000);

	let cadenas = await rawImport();

	// Notification entweder garnicht erst anzeigen oder wieder schließen
	clearTimeout(timeout);
	clearNotification();

	return cadenas;
}

function rawImport() {
	return import("./_cadenasLazy");
}
